"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXTENSION_COMMON = exports.PROVIDERS = void 0;
var PROVIDERS = {
  DROPBOX: "DROPBOX",
  GDRIVE: "GOOGLE_DRIVE",
  ONE_DRIVE: "ONE_DRIVE"
};
exports.PROVIDERS = PROVIDERS;
var EXTENSION_COMMON = {
  PDF: "PDF",
  DOC: "DOC",
  DOCX: "DOCX",
  XLS: "XLS",
  XLSX: "XLSX",
  PPT: "PPT",
  PPTX: "PPTX",
  JPG: "JPG",
  JPE: "JPE",
  JPEG: "JPEG",
  PNG: "PNG",
  BMP: "BMP",
  GIF: "GIF",
  TIFF: "TIFF",
  TIF: "TIF",
  RTF: "RTF",
  CSV: "CSV"
};
exports.EXTENSION_COMMON = EXTENSION_COMMON;